<script>
import { mapGetters } from 'vuex'
import { copyToClipboard } from '@/helpers/clipboard'

export default {
  data: () => ({
    devStage: window.config.VUE_APP_STAGE !== 'PROD'
  }),
  computed: {
    ...mapGetters(['isAuthenticated', 'jwt', 'organizations']),
    alphabeticallyOrderedPermissions() {
      return Object.keys(this.$permissions)
      .sort()
      .reduce((acc, key) => {
        acc[key] = this.$permissions[key];
        return acc;
      }, {});
    }
  },
  methods: {
    copyJwtToClipboard(withBearer) {
      try {
        withBearer
          ? copyToClipboard(`Bearer ${this.jwt}`, true, this.$t('notification.copy.bearer.jwt'))
          : copyToClipboard(this.jwt, true, this.$t('notification.copy.jwt'))
      } catch (error) {
        console.error('Error copying JWT', error)
        this.$notify(this.$t('notification.copy.jwt.error'), { type: 'error' })
      }
    },
    refreshJWT() {
      try {
        this.$store.dispatch('refreshToken')
        this.$notify(this.$t('notification.refresh.jwt'), { type: 'success' })
      } catch (error) {
        console.error('Error refreshing JWT', error)
        this.$notify(this.$t('notification.refresh.jwt.error'), {
          type: 'error'
        })
      }
    },
    dropLocalStorage() {
      try {
        localStorage.clear()
        localStorage.removeItem('vuex')
        this.$notify(this.$t('notification.drop.local.storage'), {
          type: 'success'
        })
      } catch (error) {
        console.error('Error dropping local storage', error)
        this.$notify(this.$t('notification.drop.local.storage.error'), {
          type: 'error'
        })
      }
    }
  }
}
</script>

<template>
  <span v-if="devStage && isAuthenticated">
    <!-- ORGANIZATIONS-->
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn icon color="sidebarLink" v-bind="attrs" v-on="on">
          <v-icon>mdi-office-building</v-icon>
        </v-btn>
      </template>
      <template v-for="(value, key) of organizations">
        <span v-if="value.id" :key="key" class="d-block">
          {{ value.id }}: {{ value.name }} (Admin:
          {{ value.isAdmin ? '✓' : '×' }})
        </span>
      </template>
    </v-tooltip>

    <!-- PERMISSIONS-->
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn icon color="sidebarLink" v-bind="attrs" v-on="on">
          <v-icon>mdi-badge-account</v-icon>
        </v-btn>
      </template>
      <template v-for="(value, key) of alphabeticallyOrderedPermissions">
        <span v-if="key" :key="key" class="d-block">
          {{ key }}: {{ value === true ? '✓' : '×' }}
        </span>
      </template>
    </v-tooltip>

    <!-- DROP LOCAL STORAGE-->
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          color="sidebarLink"
          v-bind="attrs"
          v-on="on"
          @click.prevent.stop="dropLocalStorage"
        >
          <v-icon>mdi-eraser</v-icon>
        </v-btn>
      </template>
      <span>Local Storage löschen</span>
    </v-tooltip>

    <!-- REFRESH JWT-->
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          color="sidebarLink"
          v-bind="attrs"
          v-on="on"
          @click.prevent.stop="refreshJWT"
        >
          <v-icon>mdi-shield-refresh</v-icon>
        </v-btn>
      </template>
      <span>JWT aktualisieren</span>
    </v-tooltip>

    <!-- COPY JWT (w.bearer) -->
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          color="sidebarLink"
          v-bind="attrs"
          v-on="on"
          @click.prevent.stop="copyJwtToClipboard(true)"
        >
          <v-icon>mdi-shield-plus</v-icon>
        </v-btn>
      </template>
      <span>JWT (mit Bearer) kopieren</span>
    </v-tooltip>

    <!-- COPY JWT -->
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-btn
          icon
          color="sidebarLink"
          v-bind="attrs"
          v-on="on"
          @click.prevent.stop="copyJwtToClipboard(false)"
        >
          <v-icon>mdi-shield</v-icon>
        </v-btn>
      </template>
      <span>JWT kopieren</span>
    </v-tooltip>
  </span>
</template>
